import { render } from "./AppLoadingSlot.vue?vue&type=template&id=788d41fa"
import script from "./AppLoadingSlot.vue?vue&type=script&lang=ts"
export * from "./AppLoadingSlot.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner});
